import type { Breakpoints } from '@withjoy/joykit/theme';

export const getMediaQuery = (breakpoint: string): string => `@media screen and (min-width: ${breakpoint})`;

export const getMediaQueries = (breakpoints: Breakpoints): string[] => {
  return breakpoints.map(getMediaQuery);
};
